import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
// import { isDesktop } from 'react-device-detect';

import { PageContentCard } from '../components';
import 'swiper/css';
import { Link, Loader } from 'theSource/components';
import { CarouselHeaderStyled } from 'theSource/features/Home/components/InboxCarousel/InboxCarouselStyled';
import { ContentBlocksPropsDto } from 'enrollment/features/EnrollmentDashboard/types';
import './index.css';

// Utility function to remove specific paragraph tags
function removeEmptyParagraphs(htmlContent: string): string {
  // This regular expression matches <p> tags that contain only a <br> tag, with optional leading/trailing spaces
  // The \s* matches any number of whitespace characters, including none
  return htmlContent.replace(/<p[^>]*>\s*<br\s*\/?>\s*<\/p>/gi, '');
}

export const BenefitsInformation = ({
  contentBlocks,
  isLoading,
  hideHeaderSection = false,
}: ContentBlocksPropsDto) => {
  const { t } = useTranslation('pages.openEnrollment');

  if (isLoading) {
    return <Loader />;
  }

  if (!contentBlocks || contentBlocks.length === 0) {
    return null;
  }

  // const isTablet = window.screen.width >= 768 && window.screen.height >= 1024;

  const showViewAllLink = contentBlocks && contentBlocks.length > 3;

  return (
    <Box data-testid="benefits-information">
      {!hideHeaderSection && (
        <CarouselHeaderStyled>
          <h2 className="mt-5 mb-4_5" id="benefits-information-title">
            {t('common:additionalInformation')}
          </h2>
          {showViewAllLink && (
            <Link
              id="view-all-benefits-information-link"
              testId="view-all-benefits-information-link"
              value={t('benefitsInformation.viewAll')}
              path="/info/view-all"
              aria-describedby="benefits-information-title"
              internal
            />
          )}
        </CarouselHeaderStyled>
      )}
      <div className="row" id="benefits-information-row">
        <div className="content-blocks-container col pb-6">
          {contentBlocks &&
            contentBlocks.slice(1).map((contentBlock) => {
              // Process the content to remove specific paragraph tags
              const content = contentBlock.content || '';
              const processedContent = removeEmptyParagraphs(content);
              return (
                <div
                  key={contentBlock.slot_num}
                  data-testid="swiper-slide"
                  className="content-block-card swiper mr-3"
                >
                  <PageContentCard
                    slotNum={contentBlock.slot_num}
                    iconImage={contentBlock.icon_image}
                    content={processedContent}
                    label={contentBlock.label}
                    documents={contentBlock.documents}
                    url={contentBlock.url}
                    urlType={contentBlock.url_type}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </Box>
  );
};
